import Swiper from 'swiper';

export default (element) => {

  const initSwiper = () => {
    const slider = element.querySelector('.swiper');
    // eslint-disable-next-line no-unused-vars
    const swiper = new Swiper(slider, {
      slidesPerView: 'auto',
      slidesOffsetBefore: 40,
      breakpoints: {
        320: {
          navigation: {
            nextEl: '.navigation-arrow-diffuser-next',
            prevEl: '.navigation-arrow-diffuser-prev',
          },
          slidesPerView: 'auto',
          slidesOffsetBefore: 20,
        },
        1024: {
          navigation: {
            nextEl: '.navigation-arrow-diffuser-next',
            prevEl: '.navigation-arrow-diffuser-prev',
          },
          slidesPerView: 'auto',
          slidesOffsetBefore: 40,
        },
      },
    });
  };

  const init = () => {
    initSwiper();
  };

  init();
};
